import type { ReactNode } from 'react';
import { messages } from '@nesc/shared';

/** S01–S03 で共通のレイアウト */
export const AuthShell = ({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: ReactNode;
}) => (
  <div className="flex min-h-dvh items-center justify-center bg-surface px-4 py-10">
    <div className="w-full max-w-sm space-y-6">
      <div className="space-y-1 text-center">
        <p className="text-h2">{messages.app.name}</p>
        <h1 className="text-h3 text-foreground-muted">{title}</h1>
        {description && <p className="text-body text-foreground-muted">{description}</p>}
      </div>
      <div className="rounded-card border border-border bg-background p-5">{children}</div>
    </div>
  </div>
);
